import { render } from "./ServiceRequest.vue?vue&type=template&id=39f341be"
import script from "./ServiceRequest.vue?vue&type=script&lang=js"
export * from "./ServiceRequest.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__